var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.1 4.9c-.4-.4-1-.4-1.4 0L12 10.6 6.3 4.9c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l5.7 5.7-5.7 5.7c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l5.7-5.7 5.7 5.7c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L13.4 12l5.7-5.7c.4-.4.4-1 0-1.4z"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
